import { Alerts, Do, IRIS, J2rButton, J2rListComponent, J2rLoadingSpinner, fsmData, j2r, moment, mutateLinksForApplication, newSystemFlyout, openNavLink, reactRender, timer, trionlineAjax, } from '../components';
import { $, React, _ } from '../lib';
let $window = null;
let tab_size = 0;
let button_size = 0;
$(window).on('load', () => refreshTabSize);
$(document).ready(() => {
    $window = $(window);
    $window.on('resize', resize_responsive);
    updateNotificationsDaemon();
    if (!$('body').hasClass('react')) {
        fixFooter();
        buildTabs();
        refreshTabSize();
        toolbarButtons();
        resize_responsive();
        handlers();
        checkSidebar();
        refreshTabSize();
        $('#hub_sidebar').css({ transition: 'transform 0.4s' });
        $(window).on('load', () => {
            refreshTabSize();
        });
    }
});
const resize_responsive = () => {
    let breaking;
    const width = $window.width();
    const thresholds = [1275, 1025, 551];
    const all = 'slim wide condensed tablet mobile';
    const body = $('#hub_body').width();
    const class_ = Do(() => {
        if (width >= thresholds[0]) {
            return 'wide';
        }
        else if (width < thresholds[0] && width >= thresholds[1]) {
            return 'condensed';
        }
        else if (width < thresholds[1] && width >= thresholds[2]) {
            return 'tablet';
        }
        else if (width < thresholds[2]) {
            return 'mobile';
        }
    });
    window.size = class_;
    $('#hub_sidebar')
        .add('#hub_body')
        .add('.to_floater')
        .add('#hub_toolbar')
        .removeClass(all)
        .addClass(class_);
    if (width < 520) {
        breaking = true;
    }
    else {
        const this_tab_size = $('#hub_content').hasClass('vertical_tabs') ? 0 : tab_size;
        const heading_size = width - this_tab_size - button_size;
        breaking = heading_size / getTitleWidth() < 0.75 ? true : heading_size < 450;
    }
    if (breaking) {
        $('#hub_body').addClass('break');
    }
    else if ($('#hub_body').hasClass('break')) {
        $('#hub_body').removeClass('break');
        refreshTabSize();
    }
    if (width < thresholds[2]) {
        $('#hub_search_q').attr('placeholder', 'Search...');
    }
    else {
        $('#hub_search_q').attr('placeholder', 'Click to search...');
    }
};
const buildTabs = () => {
    let $tabs = $('#hub_content').children('.tab_content');
    if ($tabs.length <= 1) {
        $('#hub_tabs').hide();
        return;
    }
    $tabs.each((i, elem) => {
        const $elem = $(elem);
        const title = $elem.attr('data-title');
        let ID = title.toLowerCase().replace(' ', '');
        ID = `tab_${ID}`;
        $elem.attr('id', ID);
        $('#hub_tabs').append(`<span data-key='${ID}'>${title}</span>`);
    });
    $('#hub_tabs')
        .children()
        .click(e => {
        changeTabs($(e.currentTarget));
    });
    if ($('.tab_content').first().hasClass('vertical')) {
        $tabs = $('#hub_tabs');
        $tabs.insertBefore($('#hub_content'));
        $tabs.addClass('vertical');
        $('#hub_content').addClass('vertical_tabs');
    }
    if (location.hash) {
        const ID = `tab_${location.hash.substring(1)}`;
        if ($(`#${ID}`).length > 0) {
            const $obj = $('#hub_tabs').find(`[data-key='${ID}']`);
            changeTabs($obj);
        }
    }
    else {
        changeTabs($('#hub_tabs').children().first());
    }
};
const toolbarButtons = () => {
    const $tb = $('.toolbar_buttons');
    if ($tb.length === 0) {
        $('#hub_buttons').hide();
        return;
    }
    let html = $tb.html();
    const $pb = $('#hub_buttons').html(html);
    $tb.remove();
    $pb.children().each((i, elem) => {
        const $btn = $(elem);
        const img_src = $btn.attr('data-img');
        if (img_src) {
            const text = $btn.text();
            html = `<img src='${img_src}' /><span>${text}</span>`;
            $btn.html(html);
        }
    });
    $pb.children('.tb2').addClass('toolbar');
    $pb.children().each((i, elem) => {
        const $btn = $(elem);
        $btn.attr('title', $btn.text());
    });
};
const checkSidebar = () => {
    $('#hub_sidebar')
        .find('a.selected')
        .each((i, elem) => {
        const $elem = $(elem);
        if (!$elem.hasClass('sub')) {
            return;
        }
        let $this_elem = $elem;
        while (true) {
            $this_elem = $this_elem.prev();
            if (!$this_elem.hasClass('sub')) {
                break;
            }
        }
        $this_elem.addClass('open');
        while (true) {
            $this_elem = $this_elem.next();
            if ($this_elem.hasClass('sub')) {
                $this_elem.css({ display: 'block' });
            }
            else {
                break;
            }
        }
    });
};
const changeTabs = $obj => {
    const ID = $obj.attr('data-key');
    $('#hub_tabs').children().removeClass('selected');
    $('#hub_tabs').children(`[data-key='${ID}']`).addClass('selected');
    $('.tab_content').fadeOut(100);
    timer(100, () => $('.tab_content').filter(`#${ID}`).fadeIn(100));
    const tab_key = ID.substring(4);
    const url = `${location.href.split('#')[0]}#${tab_key}`;
    history.replaceState({}, document.title, url);
    refreshTabSize();
};
export const refreshTabSize = () => {
    tab_size = $('#hub_tabs').width();
    if (!$('#hub_tabs').is(':visible')) {
        tab_size = 0;
    }
    const this_tab_size = $('#hub_content').hasClass('vertical_tabs') ? 0 : tab_size;
    $('#hub_tabs').css('width', 'auto');
    $('h1').css({ display: 'inline' });
    button_size = $('#hub_buttons').css({ display: 'inline' }).width();
    $('h1').css({ display: 'inline-block' });
    $('#hub_buttons').css({ display: '' });
    $('h1')
        .first()
        .css('width', `calc(100% - ${this_tab_size + button_size + 24}px)`);
    resize_responsive();
};
const getTitleWidth = () => {
    const $h1 = $('h1').first();
    $h1.css({ display: 'inline' });
    const width = $h1.width();
    $h1.css({ display: 'inline-block' });
    return width;
};
const fixFooter = () => {
    if (_.trim($('#admin_choice').text()) === '') {
        $('#admin_choice').empty();
    }
    if (_.trim($('#hub_acct').text()) === '') {
        $('#hub_notification_count').children().css({ visibility: 'hidden' });
    }
};
const updateNotificationsDaemon = () => {
    updateNotificationCount();
    setInterval(updateNotificationCount, 8000);
};
const updateNotificationCount = () => {
    if (!$('#hub_notification_count').hasClass('manual')) {
        IRIS.Send({
            data: {
                progID: 0,
                funcID: 6,
            },
            yes: data => {
                const count = +_.trim(data.count);
                setNotificationCount(data.count, data.urgent);
                const requiresMFA = window.rootData?.RequiresMFA ?? false;
                if (requiresMFA &&
                    !data.isElevated &&
                    !['127.0.0.1', '192.168.1.200', 'dev.localhost'].includes(location.host)) {
                    location.reload();
                }
            },
        });
    }
};
const setNotificationCount = (value, urgent) => {
    if (urgent > 0 && $('.hub-notifications-window').length === 0) {
        openNotificationFlyout(true);
    }
    if ($('.ui-root').length > 0) {
        if (window.rootUI != null) {
            window.rootUI.setState({ notificationCount: value });
            return;
        }
        else if (['trionline.com.au', 'lts.trionline.com.au'].includes(location.host)) {
            location.reload();
        }
        else {
            console.warn(`\
Frame has broken! This is a non-production server so it will not \
automatically refresh the page. But uh... yikes. See surrounding errors \
for more information to fix this.\
`);
        }
    }
    const $main = $('#hub_notification_count');
    $main.children().text(value);
    if (value === 0) {
        $main.addClass('zero');
    }
    else {
        $main.removeClass('zero');
    }
};
const handlers = () => {
    $('#hub_sidebar')
        .children()
        .click(e => {
        let $elem = $(e.currentTarget);
        $elem.toggleClass('open');
        if ($elem.hasClass('open')) {
            let $this_elem = $elem;
            return Do(() => {
                const result = [];
                while (true) {
                    $this_elem = $this_elem.next();
                    if ($this_elem.hasClass('sub')) {
                        result.push($this_elem.css({ display: 'block' }));
                    }
                    else {
                        break;
                    }
                }
                return result;
            });
        }
        return Do(() => {
            const result1 = [];
            while (true) {
                $elem = $elem.next();
                if ($elem.hasClass('sub')) {
                    result1.push($elem.hide());
                }
                else {
                    break;
                }
            }
            return result1;
        });
    });
    $('#hub_notification_count').click(() => {
        openNotificationFlyout();
    });
    $('#href_sign_out').click(() => {
        Alerts.Confirm({
            msg: 'Are you sure you want to sign out?',
            size: [320, 170],
            yes: () => {
                top.location.href = '/login/logout/';
            },
        });
    });
    $('#hub_hamburger').click(e => {
        const $img = $(e.currentTarget).children();
        if ($img.attr('src') === '/static/img/svg/hamburger.svg') {
            $img.attr('src', '/static/img/svg/hamburger-back.svg');
            $('#hub_sidebar').css({ transform: 'translate(0px, 0px)' });
            $('#hub_content').on('click', removeSidebar);
        }
        else {
            $img.attr('src', '/static/img/svg/hamburger.svg');
            $('#hub_sidebar').css({ transform: '' });
            $('#hub_content').off('click', removeSidebar);
        }
    });
    $('#hub_search_q').on({
        input: e => {
            const $elem = $(e.currentTarget);
            $elem.attr({ value: $elem.val() });
        },
        click: e => $(e.currentTarget).focus().select(),
    });
};
export const openNotificationFlyout = (auto_from_urgent) => {
    const flyout = newSystemFlyout({
        size: [480, 480],
        anchorRight: true,
        coords: [
            Do(() => {
                if (auto_from_urgent) {
                    return null;
                }
                const el = document.querySelector('body.react #hub_notification_count');
                if (el == null) {
                    return null;
                }
                return el.offsetLeft - (480 + 44) / 2;
            }),
            33,
        ],
    });
    reactRender(flyout.Element, j2r({
        tag: NotificationWindow,
        urgent: Boolean(auto_from_urgent),
        closeFlyout: flyout.Close,
    }));
};
const removeSidebar = e => {
    e.preventDefault();
    $('#hub_content').off('click', removeSidebar);
    $('#hub_hamburger').trigger('click');
};
export class NotificationWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            notifications: null,
        };
        trionlineAjax({
            url: '/api/notifications/',
            yes: data => {
                const notifications = JSON.parse(data);
                this.setState({
                    isLoading: false,
                    notifications,
                });
                const to_mark_shown = fsmData(notifications, {
                    filter: x => !x.HasShown,
                    map: x => x.ID,
                });
                if (to_mark_shown.length > 0) {
                    trionlineAjax({
                        url: '/api/notification-mark-shown/',
                        data: { keys: JSON.stringify(to_mark_shown) },
                        yes: () => {
                            const count = to_mark_shown.length;
                            console.log(`Marked ${count} notification as shown`);
                        },
                    });
                }
            },
        });
    }
    render() {
        return j2r({
            cl: 'hub-notifications-window',
            children: [
                this.buildHeading(),
                this.state.isLoading
                    ? {
                        key: 'loading-spinner-outer',
                        children: [
                            {
                                tag: J2rLoadingSpinner,
                                key: 'loading',
                                size: 'large',
                            },
                        ],
                    }
                    :
                        this.state.notifications.length === 0
                            ? {
                                key: 'stub-msg',
                                cl: 'error_msg_2 cntr',
                                style: { padding: '20%' },
                                text: 'No notifications',
                            }
                            :
                                this.buildNotificationList(),
            ],
        });
    }
    buildHeading() {
        return {
            key: 'notification-heading-line',
            cl: 'notification-heading-line',
            children: [
                {
                    cl: 'subheading',
                    key: 'subheading',
                    text: Do(() => {
                        if (this.props.urgent) {
                            return 'Urgent Notifications';
                        }
                        return 'Notifications';
                    }),
                },
                {
                    tag: J2rButton,
                    label: 'Mark All Read',
                    key: 'mark-read',
                    type: 'trans-blue',
                    disabled: this.state.isLoading,
                    onClick: () => {
                        trionlineAjax({
                            url: '/api/notification-mark-all-read/',
                            yes: () => {
                                setNotificationCount(0, 0);
                            },
                        });
                        this.props.closeFlyout();
                    },
                },
            ],
        };
    }
    buildNotificationList() {
        return {
            tag: J2rListComponent,
            key: 'notification-list',
            items: fsmData(this.state.notifications, {
                sort: x => {
                    const prefix = Do(() => {
                        if (x.IsRead) {
                            return '';
                        }
                        else if (x.HasShown || x.Priority === 1) {
                            return 'z';
                        }
                        return 'zz ';
                    });
                    return `${prefix}${x.Timestamp}`;
                },
                reverse: true,
                map: notification => this.buildNotification(notification),
            }),
        };
    }
    buildNotification(notification) {
        return {
            value: notification.ID,
            cl: Do(() => {
                let C = 'notification';
                C += ` priority_${notification.Priority}`;
                if (notification.IsRead) {
                    C += ' read';
                }
                return C;
            }),
            children: [
                {
                    tag: 'span',
                    cl: 'n-inner icon',
                    key: 'icon',
                    children: [
                        {
                            cl: 'icon-inner',
                            key: 'icon-inner',
                        },
                    ],
                },
                {
                    tag: 'span',
                    key: 'title',
                    cl: 'n-inner title',
                    text: notification.Title,
                    title: notification.Title,
                },
                {
                    tag: 'span',
                    key: 'sent',
                    cl: 'n-inner ts',
                    text: Do(() => {
                        let txt = moment(notification.Timestamp).fromNow();
                        txt = txt.replace(/minutes/, 'min');
                        txt = txt.replace(/minute/, 'min');
                        return txt;
                    }),
                    title: notification.Timestamp,
                },
                {
                    tag: 'span',
                    key: 'description',
                    cl: 'n-inner description',
                    text: notification.Text,
                    title: notification.Text,
                },
            ],
            onClick: () => {
                this.openNotification(notification);
            },
        };
    }
    openNotification(notification) {
        trionlineAjax({
            url: '/api/notification-mark-read/',
            data: { key: notification.ID },
            yes: data => {
                if (data === '') {
                    this.openLink(notification.Link);
                }
            },
        });
    }
    openLink(link) {
        if (link == null) {
            return;
        }
        if (window.rootData == null || window.rootUI == null) {
            top.location.href = link;
            return;
        }
        const [is_app, url] = mutateLinksForApplication(link);
        if (is_app) {
            openNavLink(url);
            this.props.closeFlyout();
            return;
        }
        top.location.href = url;
    }
}
//# sourceMappingURL=main-frame.js.map